module.exports = "/images/vessel-5.jpg";